import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '../components/ui/sonner';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import Seo from '../components/Seo';

/**
 * Admin app — nested router with no marketing Navbar/Footer/CookieConsent.
 * Mounted at /admin/* from App.js.
 */
export default function AdminApp() {
  return (
    <div className="admin-app">
      <Seo title="Admin" description="David Ball Management internal admin dashboard" path="/admin" noindex />
      <Routes>
        <Route path="/" element={<AdminDashboard />} />
        <Route path="login" element={<AdminLogin />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
      <Toaster position="bottom-right" theme="light" richColors />
    </div>
  );
}
